import * as types from '../../../constants/ActionTypes';
import service from '../../../service/';

export const setQuickQuote = data => ({
    type: types.SET_QUICK_QUOTE,
    data,
});

export const setApplicationType = applicationType => ({
    type: types.SET_APPLYING_TYPE,
    applicationType,
});

export const setApplicants = applicants => ({
    type: types.SET_APPLICANTS,
    applicants,
});

export const setMortgageType = mortgageType => ({
    type: types.SET_MORTGAGE_TYPE,
    mortgageType,
});

export const setApplicantsIncome = (index, event) => ({
    type: types.SET_APPLICANTS_INCOME,
    index,
    event,
});

export const setEstaminatedPropertyValue = event => ({
    type: types.SET_ESTAMINATED_PROPERTY_VALUE,
    event,
});

export const setEstaminatedPropertyMonthlyRent = event => ({
    type: types.SET_ESTAMINATED_PROPERTY_MONTHLY_RENT,
    event,
});

export const setRequestedLoanAmount = event => ({
    type: types.SET_REQUESTED_LOAN_AMOUNT,
    event,
});

export const setRequestedTimeSpan = event => ({
    type: types.SET_REQUESTED_TIME_SPAN,
    event,
});

export const getQuickQuote = params => ({
    type: types.GET_QUICK_QUOTE,
    payload: service.getQuickQuote(params),
});

export const setSampleProducts = (selectedProduct, applicationId) => ({
    type: types.SET_SAMPLE_PRODUCTS,
    payload: service.setSampleProducts(selectedProduct, applicationId),
});



// WEBPACK FOOTER //
// ./src/app/FormStepper/QuickQuote/quickQuoteActions.js